var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupAem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 473.017,
    height: 157.001,
    viewBox: "0 0 473.017 157.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(-608 -172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    transform: "translate(608 173.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1009.179,723.533a100.7,100.7,0,0,1-15.691-1.006,19.364,19.364,0,0,1-9.669-4.016,16.071,16.071,0,0,1-4.9-8.788,68.34,68.34,0,0,1-1.379-15.317V658q0-13.56,5.149-19.837t17.7-6.277h4.769a79.36,79.36,0,0,1,12.051.626,17.188,17.188,0,0,1,5.273,1.632V603.005q0-8.284-2.133-10.67t-9.165-2.384q-6.779,0-8.539,2.762t-1.757,10.293v14.816H977.543V599.994a81.641,81.641,0,0,1,1.379-16.824,17.689,17.689,0,0,1,5.149-9.667,19.456,19.456,0,0,1,10.3-4.4,114.88,114.88,0,0,1,16.823-1,135.147,135.147,0,0,1,18.328,1q7.031,1.01,10.921,4.4a17.948,17.948,0,0,1,5.4,9.667,74.9,74.9,0,0,1,1.506,16.824V721.021a75.17,75.17,0,0,1-13.81,1.883Q1024.243,723.524,1009.179,723.533Zm2.011-21.092q5.519,0,8.035-.127a15.181,15.181,0,0,0,3.262-.377V652.723a10.715,10.715,0,0,0-4.267-1.255q-2.514-.248-6.78-.253-7.282,0-8.914,2.765t-1.632,10.544v23.6q0,4.272.25,7.032a10.106,10.106,0,0,0,1.258,4.393,5.194,5.194,0,0,0,3.137,2.259A20.531,20.531,0,0,0,1011.19,702.44Z",
    transform: "translate(-977.543 -568.105)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1055.213,654.731v35.4q0,7.285,1.883,9.417t8.913,2.134q6.78,0,8.789-2.134t2.007-9.417V669.8h23.1v21.848a81.709,81.709,0,0,1-1.382,16.823,17.682,17.682,0,0,1-5.149,9.667,19.455,19.455,0,0,1-10.292,4.392,117.031,117.031,0,0,1-17.075,1.006,132.671,132.671,0,0,1-18.08-1.006q-7.031-1.007-11.047-4.392a16.927,16.927,0,0,1-5.4-9.667,81.365,81.365,0,0,1-1.382-16.823v-91.65a81.371,81.371,0,0,1,1.382-16.824,16.932,16.932,0,0,1,5.4-9.667q4.014-3.388,11.047-4.4a132.822,132.822,0,0,1,18.08-1,117.167,117.167,0,0,1,17.075,1,19.457,19.457,0,0,1,10.292,4.4,17.686,17.686,0,0,1,5.149,9.667,81.715,81.715,0,0,1,1.382,16.824v54.737Zm0-52.729v32.139h21.593V602q0-7.28-2.007-9.289t-8.789-2.008q-7.033,0-8.913,2.008T1055.213,602",
    transform: "translate(-947.068 -568.105)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(167.077 1.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1199.929,575.428a17.372,17.372,0,0,0-8.285-5.022,45.758,45.758,0,0,0-12.68-1.506q-9.546,0-15.192,3.138a22.411,22.411,0,0,0-8.913,9.165,17.353,17.353,0,0,0-8.413-9.539q-5.649-2.763-15.693-2.763-9.545,0-15.19,2.888a18.617,18.617,0,0,0-8.414,8.41V570.154H1083.3V720.56h25.609V599.783a14.434,14.434,0,0,1,4.144-5.648q2.637-2.133,7.659-2.133,6.524,0,8.786,2.258t2.262,8.035V720.56h25.612V599.533a13.393,13.393,0,0,1,4.14-5.523q2.635-2.007,7.41-2.007,6.523,0,8.789,2.258t2.257,8.035V720.56h25.612V599.533a72.146,72.146,0,0,0-1.258-14.691A20.165,20.165,0,0,0,1199.929,575.428Z",
    transform: "translate(-1083.299 -568.9)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M1205.58,720.56h-25.612V602.295q0-5.773-2.257-8.035T1168.921,592q-4.773,0-7.41,2.007a13.393,13.393,0,0,0-4.14,5.523V720.56h-25.612V602.295q0-5.773-2.262-8.035T1120.711,592q-5.027,0-7.659,2.133a14.434,14.434,0,0,0-4.144,5.648V720.56H1083.3V570.154h23.851V580.2a18.617,18.617,0,0,1,8.414-8.41q5.647-2.884,15.19-2.888,10.042,0,15.693,2.763a17.353,17.353,0,0,1,8.413,9.539,22.411,22.411,0,0,1,8.913-9.165q5.65-3.138,15.192-3.138a45.758,45.758,0,0,1,12.68,1.506,17.372,17.372,0,0,1,8.285,5.022,20.165,20.165,0,0,1,4.393,9.415,72.146,72.146,0,0,1,1.258,14.691Z",
    transform: "translate(-1083.299 -568.9)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M1009.179,723.533a100.7,100.7,0,0,1-15.691-1.006,19.364,19.364,0,0,1-9.669-4.016,16.071,16.071,0,0,1-4.9-8.788,68.34,68.34,0,0,1-1.379-15.317V658q0-13.56,5.149-19.837t17.7-6.277h4.769a79.36,79.36,0,0,1,12.051.626,17.188,17.188,0,0,1,5.273,1.632V603.005q0-8.284-2.133-10.67t-9.165-2.384q-6.779,0-8.539,2.762t-1.757,10.293v14.816H977.543V599.994a81.641,81.641,0,0,1,1.379-16.824,17.689,17.689,0,0,1,5.149-9.667,19.456,19.456,0,0,1,10.3-4.4,114.88,114.88,0,0,1,16.823-1,135.147,135.147,0,0,1,18.328,1q7.031,1.01,10.921,4.4a17.948,17.948,0,0,1,5.4,9.667,74.9,74.9,0,0,1,1.506,16.824V721.021a75.17,75.17,0,0,1-13.81,1.883Q1024.243,723.524,1009.179,723.533Zm2.011-21.092q5.519,0,8.035-.127a15.181,15.181,0,0,0,3.262-.377V652.723a10.715,10.715,0,0,0-4.267-1.255q-2.514-.248-6.78-.253-7.282,0-8.914,2.765t-1.632,10.544v23.6q0,4.272.25,7.032a10.106,10.106,0,0,0,1.258,4.393,5.194,5.194,0,0,0,3.137,2.259A20.531,20.531,0,0,0,1011.19,702.44Z",
    transform: "translate(-977.543 -568.105)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M1055.213,654.731v35.4q0,7.285,1.883,9.417t8.913,2.134q6.78,0,8.789-2.134t2.007-9.417V669.8h23.1v21.848a81.709,81.709,0,0,1-1.382,16.823,17.682,17.682,0,0,1-5.149,9.667,19.455,19.455,0,0,1-10.292,4.392,117.031,117.031,0,0,1-17.075,1.006,132.671,132.671,0,0,1-18.08-1.006q-7.031-1.007-11.047-4.392a16.927,16.927,0,0,1-5.4-9.667,81.365,81.365,0,0,1-1.382-16.823v-91.65a81.371,81.371,0,0,1,1.382-16.824,16.932,16.932,0,0,1,5.4-9.667q4.014-3.388,11.047-4.4a132.822,132.822,0,0,1,18.08-1,117.167,117.167,0,0,1,17.075,1,19.457,19.457,0,0,1,10.292,4.4,17.686,17.686,0,0,1,5.149,9.667,81.715,81.715,0,0,1,1.382,16.824v54.737Zm0-52.729v32.139h21.593V602q0-7.28-2.007-9.289t-8.789-2.008q-7.033,0-8.913,2.008T1055.213,602",
    transform: "translate(-947.068 -568.105)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(167.077 1.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1199.929,575.428a17.372,17.372,0,0,0-8.285-5.022,45.758,45.758,0,0,0-12.68-1.506q-9.546,0-15.192,3.138a22.411,22.411,0,0,0-8.913,9.165,17.353,17.353,0,0,0-8.413-9.539q-5.649-2.763-15.693-2.763-9.545,0-15.19,2.888a18.617,18.617,0,0,0-8.414,8.41V570.154H1083.3V720.56h25.609V599.783a14.434,14.434,0,0,1,4.144-5.648q2.637-2.133,7.659-2.133,6.524,0,8.786,2.258t2.262,8.035V720.56h25.612V599.533a13.393,13.393,0,0,1,4.14-5.523q2.635-2.007,7.41-2.007,6.523,0,8.789,2.258t2.257,8.035V720.56h25.612V599.533a72.146,72.146,0,0,0-1.258-14.691A20.165,20.165,0,0,0,1199.929,575.428Z",
    transform: "translate(-1083.299 -568.9)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1205.58,720.56h-25.612V602.295q0-5.773-2.257-8.035T1168.921,592q-4.773,0-7.41,2.007a13.393,13.393,0,0,0-4.14,5.523V720.56h-25.612V602.295q0-5.773-2.262-8.035T1120.711,592q-5.027,0-7.659,2.133a14.434,14.434,0,0,0-4.144,5.648V720.56H1083.3V570.154h23.851V580.2a18.617,18.617,0,0,1,8.414-8.41q5.647-2.884,15.19-2.888,10.042,0,15.693,2.763a17.353,17.353,0,0,1,8.413,9.539,22.411,22.411,0,0,1,8.913-9.165q5.65-3.138,15.192-3.138a45.758,45.758,0,0,1,12.68,1.506,17.372,17.372,0,0,1,8.285,5.022,20.165,20.165,0,0,1,4.393,9.415,72.146,72.146,0,0,1,1.258,14.691Z",
    transform: "translate(-1083.299 -568.9)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(926.885 172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(22.407 12.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M967.289,699.5a3.494,3.494,0,0,1-2.8-1.409L885.944,592.5l-13.7,85.47a3.492,3.492,0,1,1-6.9-1.1l15.005-93.643a3.493,3.493,0,0,1,6.251-1.533l.584.787,56.053,41.59L976.93,574.68a3.492,3.492,0,0,1,6.358,2.332L970.763,696.372a3.5,3.5,0,0,1-3.474,3.128ZM901.631,601.89l63.12,84.854L974.9,590.057l-27.93,40.95a3.492,3.492,0,0,1-4.966.837Z",
    transform: "translate(-865.306 -573.156)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(22.408 63.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M967.289,682.243a3.4,3.4,0,0,1-.647-.062l-98.491-18.587a3.493,3.493,0,0,1-1.278-6.345l74.657-49.383a3.491,3.491,0,0,1,5.222,1.757L970.585,677.6a3.494,3.494,0,0,1-3.3,4.648ZM877.9,658.326l84.09,15.871-20.35-58.033Z",
    transform: "translate(-865.307 -607.287)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(37.413 18.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M878.765,585.161a3.493,3.493,0,0,1-.031-6.985l99.935-.852h.032a3.493,3.493,0,0,1,.029,6.985l-99.935.852Z",
    transform: "translate(-875.273 -577.324)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(19.502)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 20.518,
    cy: 20.518,
    rx: 20.518,
    ry: 20.518,
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(0 90.407)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 25.899,
    cy: 25.899,
    rx: 25.899,
    ry: 25.899,
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(102.284 112.788)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 22.106,
    cy: 22.106,
    rx: 22.106,
    ry: 22.106,
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(84.897 51.639)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 15.288,
    cy: 15.288,
    rx: 15.288,
    ry: 15.288,
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(123.556 0.536)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 15.288,
    cy: 15.288,
    rx: 15.288,
    ry: 15.288,
    fill: "#f7f7f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAem);
export default __webpack_public_path__ + "static/media/GroupAem.c180f723849af1e62e1871022196ff63.svg";
export { ForwardRef as ReactComponent };